import { Injectable } from '@angular/core';
import { DeviceService } from "@core/services/util/device.service";
import { CartService } from '@app/core/services/cart/cart.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CustomizationComponent } from '@shared/components/customization/customization.component';
import { RepeatCustomizationComponent } from '@shared/components/customization/repeat-customization/repeat-customization.component';
import { RepeatCustomizationBottomSheetComponent } from '@shared/components/customization/repeat-customization-bottom-sheet/repeat-customization-bottom-sheet.component';

@Injectable({
    providedIn: 'root'
})
export class CustomizationUtilService {

    isMobile: boolean = false;

    constructor(
        private deviceService: DeviceService,
        private dialog: MatDialog,
        private bottomSheet: MatBottomSheet,
        private cartService: CartService
    ) {
        this.isMobile = this.deviceService.isMobile();
    }


    repeatCustomize(item, menu) {
        if (!item) {
            return
        }
        const data = {
            is_veg: item.is_veg,
            price: item.price,
            marked_price: item.marked_price,
            product_id: item.ids.product_id,
            menuData: menu,
            description: item.description
        }

        if (this.isMobile) {
            this.bottomSheet.open(RepeatCustomizationBottomSheetComponent, {
                panelClass: 'repeat-customization-sheet',
                data: data
            }).afterDismissed().subscribe(result => {
                if (result == 'repeat-last') {
                    this.cartService.incrementQuantity(item);
                } else if (result == 'add-new') {
                    this.openCustomizationModel(item.ids, data.menuData);
                }
            });
        } else {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.panelClass = 'repeat-customization-dialog';
            dialogConfig.data = data;
            dialogConfig.autoFocus = false;
            this.dialog.open(RepeatCustomizationComponent, dialogConfig).afterClosed().subscribe(result => {
                if (result == 'repeat-last') {
                    this.cartService.incrementQuantity(item);
                } else if (result == 'add-new') {
                    this.openCustomizationModel(item.ids, data.menuData);
                }

            });
        }
    }

    openCustomizationModel(productInfo, menu) {
        if(menu.products[productInfo.product_id]){
            const dialogConfig = new MatDialogConfig();
            dialogConfig.panelClass = 'customization-dialog';
            dialogConfig.data = { ...productInfo, menuData: menu };
            dialogConfig.autoFocus = false;
            this.dialog.open(CustomizationComponent, dialogConfig);
        }
    }
}
